import { localGetItem } from './Services/CacheProviderService';
import { GetInvestigationName } from '../Components/CommonFunctions/CommonFunctions';

// Module ID keys in loggedInUserInfo for multi-instance modules
const MODULE_ID_KEYS = {
  'Laboratory': 'laboratory_id',
  'Radiology': 'radiology_id',
  'Pharmacy': 'pharmacy_id',
  'sub_location': 'sublocation_id',
  'Store Sub Location': 'sublocation_id',
  'store_module': 'store_id',
  'Radiotherapy': 'radiotherapy_id',
  'Investigation': 'investigation_id',
  // Investigation module variants - all use investigation_id
  'ENDOSCOPY': 'investigation_id',
  'AUDIOMETRY': 'investigation_id',
  'SCOPY': 'investigation_id',
  'Endoscopy': 'investigation_id',
  'Audiometry': 'investigation_id',
  'Scopy': 'investigation_id'
  // front_office & master_record_department are single instance (no ID needed)
};

// Map route paths to package structure
// Format: { module, screen, mainTab, subTab }

// Function to get isBranch value dynamically (reads from localStorage each time)
const getIsBranch = () => {
  try {
    const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserInfo") || '{}');
    return loggedInUserInfo?.branch_to_branch_stock_transfer ? true : false;
  } catch (e) {
    return false;
  }
};

const getRouteToPackage = () => {
  const isNewBilling = (localGetItem('isNewBilling') === "true");

  const routeToPackageObj = {
  // =================== FRONT OFFICE ===================
  // Home Screen
  '/OPHome': { module: 'front_office', screen: 'Home' },
  '/OPHome/Appointments': { module: 'front_office', screen: 'Home', mainTab: 'OP Appointments' },
  '/OPHome/PatientDetails/Demographics': { module: 'front_office', screen: 'Home', mainTab: 'Demographics' },
  '/OPHome/PatientDetails/Billing': { module: 'front_office', screen: 'Home', mainTab: 'Billing' },
  '/OPHome/PatientDetails/SavedBill': { module: 'front_office', screen: 'Home', mainTab: 'Billing', subTab: isNewBilling ? 'Draft' : 'Saved Bill' },
  '/OPHome/PatientDetails/Bills': { module: 'front_office', screen: 'Home', mainTab: 'Billing', subTab: 'Bills' },
  '/OPHome/PatientDetails/Receipts': { module: 'front_office', screen: 'Home', mainTab: 'Billing', subTab: 'Receipts' },
  '/OPHome/PatientDetails/CreateOrder': { module: 'front_office', screen: 'Home', mainTab: 'Order', subTab: 'Create Order' },
  '/OPHome/PatientDetails/OrderList': { module: 'front_office', screen: 'Home', mainTab: 'Order', subTab: 'Order List' },
  '/OPHome/PatientDetails/CancelledOrder': { module: 'front_office', screen: 'Home', mainTab: 'Order', subTab: 'Cancelled Order' },
  '/OPHome/PatientDetails/NurseNotes': { module: 'front_office', screen: 'Home', mainTab: 'Nurse Notes' },
  '/OPHome/PatientDetails/NurseNotes': { module: 'front_office', screen: 'Home', mainTab: 'Nurse Notes', subTab: 'Vitals' },
  '/OPHome/PatientDetails/TreatmentPlan': { module: 'front_office', screen: 'Home', mainTab: 'Nurse Notes', subTab: 'Treatment Plan' },
  '/OPHome/PatientDetails/Notes': { module: 'front_office', screen: 'Home', mainTab: 'Nurse Notes', subTab: 'Notes' },
  '/OPHome/PatientDetails/DoctorVisitReports': { module: 'front_office', screen: 'Home', mainTab: 'Doctor Visit Reports' },
  '/OPHome/PatientDetails/TestReports': { module: 'front_office', screen: 'Home', mainTab: 'Test Reports' },
  '/OPHome/PatientDetails/PrintOrderReports': { module: 'front_office', screen: 'Home', mainTab: 'Print Order Reports' },
  '/OPHome/PatientDetails/InsuranceDetails': { module: 'front_office', screen: 'Home', mainTab: 'Insurance' },
  '/OPHome/PatientDetails/InsuranceDetails/InsuDetails': { module: 'front_office', screen: 'Home', mainTab: 'Insurance', subTab: 'Insurance Details' },
  '/OPHome/PatientDetails/InsuranceDetails/PreAuth': { module: 'front_office', screen: 'Home', mainTab: 'Insurance', subTab: 'Pre Authorization' },
  '/OPHome/PatientDetails/InsuranceDetails/ClaimDetails': { module: 'front_office', screen: 'Home', mainTab: 'Insurance', subTab: 'Claim Details' },
  '/OPHome/PatientDetails/Corporate': { module: 'front_office', screen: 'Home', mainTab: 'Corporate' },
  '/OPHome/PatientDetails/CorporateDetails': { module: 'front_office', screen: 'Home', mainTab: 'Corporate' },
  '/OPHome/PatientDetails/CorporateDetails/ClaimDetails': { module: 'front_office', screen: 'Home', mainTab: 'Corporate', subTab: 'Claim Details' },
  '/OPHome/PatientDetails/PatientDocument': { module: 'front_office', screen: 'Home', mainTab: 'Patient Document' },
  '/OPHome/PatientDetails/DeathCertificate': { module: 'front_office', screen: 'Home', mainTab: 'Form 4/4A' },
  '/OPHome/PatientDetails/DischargeSummaryReports': { module: 'front_office', screen: 'Home', mainTab: 'Discharge Summary Reports' },
  '/OPHome/PatientDetails/SurgeryReports': { module: 'front_office', screen: 'Home', mainTab: 'Surgery Reports' },

  // In Patients Screen
  '/IPHome': { module: 'front_office', screen: 'In Patients' },
  '/IPHome/Reservation': { module: 'front_office', screen: 'In Patients', mainTab: 'Reservation' },
  '/IPHome/BedAvailability': { module: 'front_office', screen: 'In Patients', mainTab: 'Bed Availability' },
  '/IPHome/Estimation': { module: 'front_office', screen: 'In Patients', mainTab: 'Estimation' },
  '/IPHome/Occupancy': { module: 'front_office', screen: 'In Patients', mainTab: 'Occupancy' },
  '/IPHome/OThome': { module: 'front_office', screen: 'In Patients', mainTab: 'OT List' },
  '/IPHome/PatientDetails/PatientDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Patient Details' },
  '/IPHome/PatientDetails/ServiceBilling': { module: 'front_office', screen: 'In Patients', mainTab: 'Service Billing' },
  '/IPHome/PatientDetails/IpBills': { module: 'front_office', screen: 'In Patients', mainTab: 'Service Billing', subTab: 'Bills' },
  '/IPHome/PatientDetails/IpReceiptsBill': { module: 'front_office', screen: 'In Patients', mainTab: 'Service Billing', subTab: 'Receipts' },
  '/IPHome/PatientDetails/CreateOrder': { module: 'front_office', screen: 'In Patients', mainTab: 'Order', subTab: 'Create Order' },
  '/IPHome/PatientDetails/OrderList': { module: 'front_office', screen: 'In Patients', mainTab: 'Order', subTab: 'Order List' },
  '/IPHome/PatientDetails/CancelledOrder': { module: 'front_office', screen: 'In Patients', mainTab: 'Order', subTab: 'Cancelled Order' },
  '/IPHome/PatientDetails/RoomChange': { module: 'front_office', screen: 'In Patients', mainTab: 'Room Change' },
  '/IPHome/PatientDetails/ReceivePayment': { module: 'front_office', screen: 'In Patients', mainTab: 'Receive Payment' },
  // Clinical Notes sub tabs
  '/IPHome/PatientDetails/ClinicalNotes': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes' },
  '/IPHome/PatientDetails/ClinicalNotes/Vitals': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Vitals' },
  '/IPHome/PatientDetails/ClinicalNotes/MonitoringChart': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Monitoring Chart' },
  '/IPHome/PatientDetails/ClinicalNotes/VentilationFlowSheet': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Ventilation Flow Sheet' },
  '/IPHome/PatientDetails/ClinicalNotes/NurseAssessments': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Nurse Assessments' },
  '/IPHome/PatientDetails/ClinicalNotes/DoctorNotes': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Doctor Notes' },
  '/IPHome/PatientDetails/ClinicalNotes/NurseNotes': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Nurse Notes' },
  '/IPHome/PatientDetails/ClinicalNotes/IVTrack': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'IV / IM Track' },
  '/IPHome/PatientDetails/ClinicalNotes/DrugChart': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Drug Chart' },
  '/IPHome/PatientDetails/ClinicalNotes/PainChart': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Pain Chart' },
  '/IPHome/PatientDetails/ClinicalNotes/NutritionChart': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Nutrition Chart' },
  '/IPHome/PatientDetails/ClinicalNotes/InputOutputChart': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Input/OutPut Chart' },
  '/IPHome/PatientDetails/ClinicalNotes/Medication': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Medication' },
  '/IPHome/PatientDetails/ClinicalNotes/Laboratory': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Laboratory' },
  '/IPHome/PatientDetails/ClinicalNotes/TestOrder': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Test Order' },
  '/IPHome/PatientDetails/ClinicalNotes/GlucoseLog': { module: 'front_office', screen: 'In Patients', mainTab: 'Clinical Notes', subTab: 'Glucose Log' },
      // Reports sub tabs
  '/IPHome/PatientDetails/Reports': { module: 'front_office', screen: 'In Patients', mainTab: 'Reports' },
  '/IPHome/PatientDetails/Reports/TestReport': { module: 'front_office', screen: 'In Patients', mainTab: 'Reports', subTab: 'Test Report' },
  '/IPHome/PatientDetails/Reports/PrintOrderReport': { module: 'front_office', screen: 'In Patients', mainTab: 'Reports', subTab: 'Print Order Report' },
  // History sub tabs
  '/IPHome/PatientDetails/History': { module: 'front_office', screen: 'In Patients', mainTab: 'History' },
  '/IPHome/PatientDetails/History/MedicalHistory': { module: 'front_office', screen: 'In Patients', mainTab: 'History', subTab: 'Medical History' },
  '/IPHome/PatientDetails/History/HospitalizationHistory': { module: 'front_office', screen: 'In Patients', mainTab: 'History', subTab: 'Hospitalization History' },
  '/IPHome/PatientDetails/History/SocialHistory': { module: 'front_office', screen: 'In Patients', mainTab: 'History', subTab: 'Social History' },
  '/IPHome/PatientDetails/History/FamilyHistory': { module: 'front_office', screen: 'In Patients', mainTab: 'History', subTab: 'Family History' },
  '/IPHome/PatientDetails/DischargeSummary': { module: 'front_office', screen: 'In Patients', mainTab: 'Discharge Summary' },
  '/IPHome/PatientDetails/SurgeryNotes': { module: 'front_office', screen: 'In Patients', mainTab: 'Surgery Notes' },
  '/IPHome/PatientDetails/PatientDocuments': { module: 'front_office', screen: 'In Patients', mainTab: 'Patient Document' },
  '/IPHome/PatientDetails/DeathCertificate': { module: 'front_office', screen: 'In Patients', mainTab: 'Form 4/4A' },
  // Insurance sub tabs
  '/IPHome/PatientDetails/InsuranceDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Insurance' },
  '/IPHome/PatientDetails/InsuranceDetails/InsuDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Insurance', subTab: 'Insurance Details' },
  '/IPHome/PatientDetails/InsuranceDetails/PreAuth': { module: 'front_office', screen: 'In Patients', mainTab: 'Insurance', subTab: 'Pre Authorization' },
  '/IPHome/PatientDetails/InsuranceDetails/ClaimDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Insurance', subTab: 'Claim Details' },
  // Corporate sub tabs
  '/IPHome/PatientDetails/Corporate': { module: 'front_office', screen: 'In Patients', mainTab: 'Corporate' },
  '/IPHome/PatientDetails/CorporateDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Corporate' },
  '/IPHome/PatientDetails/CorporateDetails/ClaimDetails': { module: 'front_office', screen: 'In Patients', mainTab: 'Corporate', subTab: 'Claim Details' },
  // Consent Forms
  '/IPHome/PatientDetails/ConsentForms': { module: 'front_office', screen: 'In Patients', mainTab: 'Consent Forms' },
  '/IPHome/PatientDetails/ConsentForms/Add': { module: 'front_office', screen: 'In Patients', mainTab: 'Consent Forms' },

  // RT WalkIn
  '/RadiotherapyWalkIn': { module: 'front_office', screen: 'RT WalkIn' },

  // Hospital Billing
  '/HospitalBilling': { module: 'front_office', screen: 'Hospital Billing' },
  '/HospitalBilling/HospitalBilling': { module: 'front_office', screen: 'Hospital Billing', mainTab: 'Hospital Billing' },
  '/HospitalBilling/CashCounter': { module: 'front_office', screen: 'Hospital Billing', mainTab: 'Cash Counter' },
  '/HospitalBilling/PendingList': { module: 'front_office', screen: 'Hospital Billing', mainTab: 'Pending List' },

  // Billing Transaction
  '/BillingTransaction': { module: 'front_office', screen: 'Billing Transaction' },
  '/BillingTransaction/BillingCollectionSummary': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Billing & Collection Summary' },
  '/BillingTransaction/OverAllBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Overall Bills' },
  '/BillingTransaction/CreditBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Credit Bills' },
  '/BillingTransaction/Order': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Order' },
  '/BillingTransaction/CancelledBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Cancelled Bills' },
  '/BillingTransaction/SavedBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: isNewBilling ? 'Draft Bills' : 'Saved Bills' },
  '/BillingTransaction/ReceiptBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Receipt Bills' },
  '/BillingTransaction/DayEnd': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Day End' },
  '/BillingTransaction/Expenses': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Expenses' },
  '/BillingTransaction/DetailedReceiptBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Detailed Receipt Bills' },
  '/BillingTransaction/AdvanceDetailed': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Advance Deduction Detailed' },
  '/BillingTransaction/DayEndDenomination': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Day End Denomination' },
  '/BillingTransaction/MakerApprovalTransactions': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Maker/Checker Transactions' },
  '/BillingTransaction/MembershipBills': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Membership Bills' },
  '/BillingTransaction/AdvanceAdded': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'Advance Added' },
  '/BillingTransaction/UserDayEndSalesReport': { module: 'front_office', screen: 'Billing Transaction', mainTab: 'User Day End Report' },

  // Reports
  '/FOReports': { module: 'front_office', screen: 'Reports' },
  '/FOReports/ServiceReports/ServiceDetailed': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'OP Service Detailed' },
  '/FOReports/ServiceReports/ServiceOverview': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'OP Service Overview' },
  '/FOReports/ServiceReports/OPServiceShare': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'OP Service Share' },
  '/FOReports/ServiceReports/ConsultWiseReport': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'Consultation Wise Report' },
  '/FOReports/ServiceReports/OPGSTReport': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'OP GST Report' },
  '/FOReports/ServiceReports/OPServiceHeadWiseReport': { module: 'front_office', screen: 'Reports', mainTab: 'OP Service Reports', subTab: 'OP Service Head-Wise Report' },
  '/FOReports/IpServiceReport/IPServiceDetailed': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Service Detailed' },
  '/FOReports/IpServiceReport/IPServiceOverview': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Service Overview' },
  '/FOReports/ServiceReports/IPServiceShare': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Service Share' },
  '/FOReports/IpServiceReport/IPAdmissionList': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Admission List' },
  '/FOReports/IpServiceReport/IPDischargeList': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Discharge List' },
  '/FOReports/IpServiceReport/IPOccupancyReport': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Occupancy Report' },
  '/FOReports/ServiceReports/IPGSTReport': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP GST Report' },
  '/FOReports/ServiceReports/IPServiceHeadWiseReport': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Service Head-Wise Report' },
  '/FOReports/IpServiceReport/IPPaymentDueReport': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP Payment Due Report' },
  '/FOReports/IpServiceReport/IPMLCReport': { module: 'front_office', screen: 'Reports', mainTab: 'IP Service Reports', subTab: 'IP MLC Report' },
  '/FOReports/CorporateReports/BillReport': { module: 'front_office', screen: 'Reports', mainTab: 'Corporate and Insurance Reports', subTab: 'Corporate Patient Bill Report' },
  '/FOReports/CorporateReports/PaymentReport': { module: 'front_office', screen: 'Reports', mainTab: 'Corporate and Insurance Reports', subTab: 'Corporate Payment Report' },
  '/FOReports/CorporateReports/InsuranceReport': { module: 'front_office', screen: 'Reports', mainTab: isNewBilling ? 'Insurance Reports' : 'Corporate and Insurance Reports', subTab: 'Insurance Patient Bill Report' },
  '/FOReports/AppointmentReports/PatientReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: isNewBilling ? 'Patients Appointment Report' : "Patient Based Appointment Report" },
  '/FOReports/AppointmentReports/DoctorReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: isNewBilling ? 'Doctors Appointment Report' : "Doctor Based Appointment Report" },
  '/FOReports/AppointmentReports/SpecializationReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: isNewBilling ? 'Specialization Appointment Report' : "Specialization Based Appointment Report" },
  '/FOReports/AppointmentReports/TypeBasedReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: isNewBilling ? 'Appointment Type Report' : "Type Based Appointment Report" },
  '/FOReports/AppointmentReports/TATReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: 'TAT Report' },
  '/FOReports/AppointmentReports/NoShowReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: 'No Show Report' },
  '/FOReports/AppointmentReports/CounsellorSurgeryReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: 'Counsellor Surgery Conversion Report' },
  '/FOReports/AppointmentReports/IMARegistrationReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: 'IMA Registration Report' },
  '/FOReports/AppointmentReports/AppointmentRequestReport': { module: 'front_office', screen: 'Reports', mainTab: 'Appointment Reports', subTab: 'Appointment Request Report' },
  '/FOReports/PatientReport/PatientDemographicReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Patient Demographics Report' },
  '/FOReports/PatientReport/PurposeOfVisitReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Purpose Of Visit Report' },
  '/FOReports/PatientReport/ReasonDiagnosisReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Reason / Diagnosis Report' },
  '/FOReports/PatientReport/ConcessionReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Concession Report' },
  '/FOReports/PatientReport/PreviousCreditAdjustmentReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Previous Credit Adjustment Report' },
  '/FOReports/PatientReport/CreditSettlementReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Credit Settlement Report' },
  '/FOReports/PatientReport/MembershipReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Membership Report' },
  '/FOReports/PatientReport/SMSReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Message Report' },
  '/FOReports/PatientReport/ServiceConsolidateReport': { module: 'front_office', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Doctor wise - Service Consolidate Report' },
  '/FOReports/ReferralReports/ReferenceReport': { module: 'front_office', screen: 'Reports', mainTab: 'Referral Reports', subTab: 'Referral Report' },
  '/FOReports/ReferralReports/ReferenceCount': { module: 'front_office', screen: 'Reports', mainTab: 'Referral Reports', subTab: 'Referral Count' },
  '/FOReports/ReferralReports/ReferenceTypePatientCount': { module: 'front_office', screen: 'Reports', mainTab: 'Referral Reports', subTab: 'Referral Type Wise Patient Count' },
  '/FOReports/OptometristReports/OptometristList': { module: 'front_office', screen: 'Reports', mainTab: 'Optometrist Reports', subTab: 'Optometrist List' },
  '/FOReports/OptReports/OpticalCRMReport': { module: 'front_office', screen: 'Reports', mainTab: 'Ophthalmology Reports', subTab: 'Optical CRM Sales' },
  '/FOReports/OptReports/PrescriptionReport': { module: 'front_office', screen: 'Reports', mainTab: 'Ophthalmology Reports', subTab: 'Prescription Report' },
  '/FOReports/TallyReports/GenerateReport': { module: 'front_office', screen: 'Reports', mainTab: 'Generate Report', subTab: 'Generate Report' },

  // Settings
  '/Settings': { module: 'front_office', screen: 'Settings' },
  // Hospital Configuration
  '/Settings/HospitalConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration' },
  '/Settings/OPService/Specialization': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Specialization' },
  '/Settings/HospitalConfig/DoctorList': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Doctor List' },
  '/Settings/HospitalConfig/SlotConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Slot Configuration' },
  '/Settings/OPService/TokenPrefix': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Token Prefix' },
  '/Settings/OPService/AppointmentType': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Appointment Type' },
  '/Settings/OPService/TagConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Tag' },
  '/Settings/CustomConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Custom Configuration' },
  '/Settings/ExpenseConfig/ExpenseCategory': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Expense Category' },
  '/Settings/HospitalConfig/HospitalConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Hospital Configuration' },
  '/Settings/HospitalConfig/QMSConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'QMS Configuration' },
  '/Settings/HospitalConfig/ClinicalStaff': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Clinic Staff' },
  '/Settings/HospitalConfig/ClinicalStaffMapping': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Clinic Staff Mapping' },
  '/Settings/HospitalConfig/PurposeOfVisit': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Purpose of Visit' },
  '/Settings/HospitalConfig/DiagnosisReason': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Diagnosis Reason' },
  '/Settings/HospitalConfig/OptometristMapping': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Optometrist Mapping' },
  '/Settings/HospitalConfig/BankDetailsMaster': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'Bank & Account Setup' },
  '/Settings/HospitalConfig/ExternalDrugMaster': { module: 'front_office', screen: 'Settings', mainTab: 'Hospital Configuration', subTab: 'External Drug Master' },
  // OP Service Configuration
  '/Settings/OPService/ServiceNameTypeConfig': { module: 'front_office', screen: 'Settings', mainTab: 'OP Service Configuration', subTab: 'Service Name & Type Config' },
  '/Settings/OPService/ServiceTemplates': { module: 'front_office', screen: 'Settings', mainTab: 'OP Service Configuration', subTab: 'Service Template' },
  '/Settings/OPService/CorporateServiceConfig': { module: 'front_office', screen: 'Settings', mainTab: 'OP Service Configuration', subTab: 'Corporate Service Config' },
  // Referral Configuration
  '/Settings/ReferralConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Referral Configuration' },
  '/Settings/ReferralConfig/SourceConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Referral Configuration', subTab: 'Referral Source' },
  '/Settings/ReferralConfig/DoctorConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Referral Configuration', subTab: 'Referral Doctor' },
  '/Settings/ReferralConfig/ReferralSource': { module: 'front_office', screen: 'Settings', mainTab: 'Referral Configuration', subTab: 'Referral Staff' },
  // Corporate Configuration
  '/Settings/CorporateConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Corporate Configuration' },
  '/Settings/CorporateConfig/CorporateEnroll': { module: 'front_office', screen: 'Settings', mainTab: 'Corporate Configuration', subTab: 'Corporate' },
  '/Settings/CorporateConfig/PatientDetails': { module: 'front_office', screen: 'Settings', mainTab: 'Corporate Configuration', subTab: 'Patient Details' },
  // Room Configuration
  '/Settings/RoomConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Room Configuration' },
  '/Settings/RoomConfig/HospitalConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Room Configuration', subTab: 'Block & Floor Configuration' },
  '/Settings/RoomConfig/WardConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Room Configuration', subTab: 'Ward Configuration' },
  '/Settings/RoomConfig/BedConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Room Configuration', subTab: 'Bed Configuration' },
  // Insurance Configuration
  '/Settings/InsuranceConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Insurance Configuration' },
  '/Settings/InsuranceConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Insurance Configuration', subTab: 'Insurance Configuration' },
  // Message Configuration
  '/Settings/MessageConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Message Configuration' },
  '/Settings/MessageConfig/Request': { module: 'front_office', screen: 'Settings', mainTab: 'Message Configuration', subTab: 'Message Request' },
  '/Settings/MessageConfig/Config': { module: 'front_office', screen: 'Settings', mainTab: 'Message Configuration', subTab: 'Message Configuration' },
  // MRD Configuration
  '/Settings/MRDConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'MRD Configuration' },
  '/Settings/MrdConfig/Department': { module: 'front_office', screen: 'Settings', mainTab: 'MRD Configuration', subTab: 'Department Master' },
  '/Settings/MrdConfig/ConsultationRoomConfig': { module: 'front_office', screen: 'Settings', mainTab: 'MRD Configuration', subTab: 'Consultation Room Configuration' },
  '/Settings/MrdConfig/NurseStationConfig': { module: 'front_office', screen: 'Settings', mainTab: 'MRD Configuration', subTab: 'Nurse Station' },
  '/Settings/MrdConfig/OtherRoomConfig': { module: 'front_office', screen: 'Settings', mainTab: 'MRD Configuration', subTab: 'Other Rooms' },
  // Membership Configuration
  '/Settings/MembershipConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Membership Configuration' },
  '/Settings/MembershipConfiguration/PackageConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Membership Configuration', subTab: 'Package Configuration' },
  '/Settings/MembershipConfiguration/MembershipCreation': { module: 'front_office', screen: 'Settings', mainTab: 'Membership Configuration', subTab: 'Membership Creation' },
  // Service Master Configuration (New Service)
  '/Settings/ServiceMasterConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration' },
  '/Settings/NewService/DepartmentMaster': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Service Master' },
  '/Settings/NewService/HospitalEmergency': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Holiday/Emergency' },
  '/Settings/NewService/AutoBillingConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Auto Billing' },
  '/Settings/NewService/TemplateConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Template Configuration' },
  '/Settings/NewService/PackageConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Package Configuration' },
  '/Settings/NewService/CorpPackageConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Corporate Service Configuration' },
  '/Settings/NewService/InsurancePackageConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Insurance Package Configuration' },
  '/Settings/NewService/SurgeryMaster': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Surgery Master' },
  '/Settings/NewService/SurgeryMapping': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Surgery Mapping' },
  '/Settings/NewService/DrugMaster': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Drug Master' },
  '/Settings/NewService/DrugPackage': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Drug Template' },
  '/Settings/NewService/AssortedPackage': { module: 'front_office', screen: 'Settings', mainTab: 'Service Master Configuration', subTab: 'Assorted Package' },
  // IP Service Configuration
  '/Settings/IPServiceConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'IP Service Configuration' },
  '/Settings/IPService/SurgeryConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'IP Service Configuration', subTab: 'Surgery Configuration' },
  '/Settings/IPService/IPServiceNameTypeConfig': { module: 'front_office', screen: 'Settings', mainTab: 'IP Service Configuration', subTab: 'IP Service Name & Type Config' },
  '/Settings/IPService/IPPackageConfig': { module: 'front_office', screen: 'Settings', mainTab: 'IP Service Configuration', subTab: 'IP Package Configuration' },
  // Telemedicine Configuration
  '/Settings/TelemedicineConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Telemedicine Configuration' },
  '/Settings/TelemedicineConfiguration/TelemedicineRequest': { module: 'front_office', screen: 'Settings', mainTab: 'Telemedicine Configuration', subTab: 'Telemedicine Request' },
  // Layout Configuration
  '/Settings/LayoutConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration' },
  '/Settings/DemographicsConfig/DemographicsLayout': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Demographics Configuration' },
  '/Settings/LayoutConfig/DisSummaryLayoutConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Discharge Summary Layout' },
  '/Settings/LayoutConfig/SurgeryNotesLayout': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Surgery Notes Layout' },
  '/Settings/PrintConfig/PrintSettings': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Print Configuration' },
  '/Settings/LayoutConfig/VitalConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Vital Configuration' },
  '/Settings/LayoutConfig/IPDoctorNotesLayout': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'IP Doctor Notes Layout' },
  '/Settings/LayoutConfig/IPPrintConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'IP Detailed Print Configuration' },
  '/Settings/LayoutConfig/MedicalRecordConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Medical Record Print Configuration' },
  '/Settings/LayoutConfig/ConsentFormConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Consent Configuration' },
  '/Settings/LayoutConfig/ConsentFormConfiguration/Add': { module: 'front_office', screen: 'Settings', mainTab: 'Layout Configuration', subTab: 'Consent Configuration' },
  // Template Configuration
  '/Settings/TemplateConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Template Configuration' },
  '/Settings/TemplateConfig/DisSumTemplateConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Template Configuration', subTab: 'Discharge Summary Template Configuration' },
  '/Settings/TemplateConfig/SurgeryTemplateConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Template Configuration', subTab: 'Surgery Notes Template Configuration' },
  // Card Layout Configuration
  '/Settings/CardConfiguration': { module: 'front_office', screen: 'Settings', mainTab: 'Card Layout Configuration' },
  '/Settings/CardConfig/CardLayoutConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Card Layout Configuration', subTab: 'Card Layout Configuration' },
  '/Settings/CardConfig/IPLayoutConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Card Layout Configuration', subTab: 'Inpatient Label Layout Configuration' },
  '/Settings/CardConfig/AttendercardLayoutConfig': { module: 'front_office', screen: 'Settings', mainTab: 'Card Layout Configuration', subTab: 'Attender Card Layout Configuration' },
  // ABDM
  '/ABDM': { module: 'front_office', screen: 'ABDM' },
  '/ABDM/Register': { module: 'front_office', screen: 'ABDM', mainTab: 'Registration' },
  '/ABDM/verify': { module: 'front_office', screen: 'ABDM', mainTab: 'Verification' },
  '/ABDM/Consent': { module: 'front_office', screen: 'ABDM', mainTab: 'Consent' },
  '/ABDM/HIU': { module: 'front_office', screen: 'ABDM', mainTab: 'Consent List' },
  '/ABDM/PatientList': { module: 'front_office', screen: 'ABDM', mainTab: 'Patient List' },

  // =================== RADIOTHERAPY ===================
  '/RadiotherapyStimulation': { module: 'Radiotherapy', screen: 'Stimulation' },
  '/RadiotherapyDosimetrist': { module: 'Radiotherapy', screen: 'Dosimetrist' },
  '/RadiotherapyScheduler': { module: 'Radiotherapy', screen: 'Scheduler' },
  '/RadiotherapyTherapist': { module: 'Radiotherapy', screen: 'Therapist' },
  '/RadiotherapyTherapist/TherapySession': { module: 'Radiotherapy', screen: 'Therapist', mainTab: 'Therapist', subTab: 'Therapy Session' },
  '/RadiotherapyReports': { module: 'Radiotherapy', screen: 'Reports' },
  '/RadiotherapyReports/RtTATReport': { module: 'Radiotherapy', screen: 'Reports', mainTab: 'RT Session TAT Report' },
  '/RadiotherapyReports/RtPatientReport': { module: 'Radiotherapy', screen: 'Reports', mainTab: 'RT Patient Report' },

  '/RadiotherapySetting': { module: 'Radiotherapy', screen: 'Settings' },
  '/RadiotherapySetting/TherapyConfiguration/TherapyMaster': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Therapy Master' },
  '/RadiotherapySetting/TherapyConfiguration/TreatmentRegion': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Treatment Region' },
  '/RadiotherapySetting/TherapyConfiguration/TreatmentTechnique': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Therapy Technique' },
  '/RadiotherapySetting/TherapyConfiguration/StimulatorMaster': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Stimulator Master' },
  '/RadiotherapySetting/TherapyConfiguration/ImmobilizationDeviceMaster': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Immobilization Device Master' },
  '/RadiotherapySetting/TherapyConfiguration/RadiotherapyTagMaster': { module: 'Radiotherapy', screen: 'Settings', mainTab: 'Radiotherapy Masters', subTab: 'Radiotherapy Tag' },

  // =================== PHARMACY ===================
  '/PharmacyBilling': { module: 'Pharmacy', screen: 'Billing' },
  '/PharmacyBilling/Return': { module: 'Pharmacy', screen: 'Billing', mainTab: 'Return Bills' },
  '/PharmacyBilling/CashCounter': { module: 'Pharmacy', screen: 'Billing', mainTab: 'Cash Counter' },
  '/PharmacyInvoice': { module: 'Pharmacy', screen: 'Billing Transaction' },
  '/PharmacyInvoice/Invoice': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Overall Bills' },
  '/PharmacyInvoice/CreditBills': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Credit Bills' },
  '/PharmacyInvoice/SavedBills': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Saved Bills' },
  '/PharmacyInvoice/ReceiptBills': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Receipt Bills' },
  '/PharmacyInvoice/DayEndDenomination': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Day End Denomination' },
  '/PharmacyInvoice/Expenses': { module: 'Pharmacy', screen: 'Billing Transaction', mainTab: 'Expenses' },
  '/PharmacyInventory': { module: 'Pharmacy', screen: 'Inventory' },
  '/PharmacyInventory/StockList': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'Stock List' },
  '/PharmacyInventory/DrugList': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'Drug List' },
  '/PharmacyInventory/InactiveDrugList': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'Inactive Drug List' },
  '/PharmacyInventory/StockCorrection': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'Stock Correction' },
  '/PharmacyInventory/NewDrugApproval': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'New Drug Approval' },
  '/PharmacyInventory/AuditLog': { module: 'Pharmacy', screen: 'Inventory', mainTab: 'Master Correction' },
  '/PharmacyPurchase': { module: 'Pharmacy', screen: 'Purchase' },
  '/PharmacyPurchase/PurchaseRequest': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Purchase Request' },
  '/PharmacyPurchase/PurchaseOrder': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Purchase Inward' },
  '/PharmacyPurchase/DeliveryChallan': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Delivery Challan' },
  '/PharmacyPurchase/VendorPayment': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Vendor Payment' },
  '/PharmacyPurchase/VendorList': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Vendor List' },
  '/PharmacyPurchase/PurchaseReturn': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Purchase Return' },
  '/PharmacyPurchase/PurchaseRejection': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Purchase Rejection' },
  '/PharmacyPurchase/CreditNote': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Credit Note' },
  '/PharmacyPurchase/WantedList': { module: 'Pharmacy', screen: 'Purchase', mainTab: 'Wanted List' },
  '/PharmacyReports': { module: 'Pharmacy', screen: 'Reports' },

  '/PharmacyReports/SalesOverview': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Overview' },
  '/PharmacyReports/SalesDetailed': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Detailed' },
  '/PharmacyReports/SalesReturn': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Return' },
  '/PharmacyReports/SalesDayEnd': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Day End' },
  '/PharmacyReports/SalesMonthly': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Monthly' },
  '/PharmacyReports/ProductWiseSales': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Product Wise Sales' },
  '/PharmacyReports/HsnWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'HSN Wise' },
  '/PharmacyReports/TaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Tax Wise' },
  '/PharmacyReports/ReturnHSNWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Return HSN Wise' },
  '/PharmacyReports/ReturnTaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Return Tax Wise' },
  '/PharmacyReports/PrescriptionRegister': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Prescription Register' },
  '/PharmacyReports/ProfitAnalysis': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Profit Analysis' },
  '/PharmacyReports/billTaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Bill Tax Wise' },
  '/PharmacyReports/UserSalesPerformance': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'User Sales Performance' },
  '/PharmacyReports/CorporatePatientBillReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Corporate Patient Bill Report' },
  '/PharmacyReports/CreditSettlementPharmacyReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Credit Settlement Report' },
  '/PharmacyReports/DiscountReportPharmacy': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Sales Discount Report' },
  '/PharmacyReports/DoorDeliveryReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Door Delivery Report' },
  '/PharmacyReports/IssuedDrugReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Issued Drug Report' },
  '/PharmacyReports/DrugUtilization': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Sales Reports', subTab: 'Drug Utilization' },

  '/PharmacyReports/PurchaseOverview': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Overview' },
  '/PharmacyReports/PurchsaeDetailed': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Detailed' },
  '/PharmacyReports/PurchaseGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase GST' },
  '/PharmacyReports/PurchaseReturnOverview': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return Overview' },
  '/PharmacyReports/PurchaseReturnDetailed': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return Detailed' },
  '/PharmacyReports/PurchaseMonthly': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Monthly' },
  '/PharmacyReports/VendorBill': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Vendor Wise' },
  '/PharmacyReports/PurchaseHSNWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase HSN Wise' },
  '/PharmacyReports/PurchaseTaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Tax Wise' },
  '/PharmacyReports/PurchaseReturnHSNWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return HSN Wise' },
  '/PharmacyReports/ReturnVendorWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return Vendor Wise' },
  '/PharmacyReports/PurchaseReturnTaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return Tax Wise' },
  '/PharmacyReports/PurchaseWiseEnquiry': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Wise Enquiry' },
  '/PharmacyReports/PurchaseRejection': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Rejection' },
  '/PharmacyReports/CreditNoteReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Credit Note Report' },
  '/PharmacyReports/PurchaseBillTaxWise': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Bill Tax Wise' },

  '/PharmacyReports/StockOverview': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Overview' },
  '/PharmacyReports/MISReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'MIS Report' },
  '/PharmacyReports/ExpiryStock': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Expiry Stock' },
  '/PharmacyReports/LowStockDrugs': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Low Stock Drugs' },
  '/PharmacyReports/DrugMovementReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Drug Movement Report' },
  '/PharmacyReports/StockCorrectionLog': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Correction Log Report' },
  '/PharmacyReports/StockValueReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Value Detail' },
  '/PharmacyReports/StockAndProfitValue': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock And Profit Value' },
  '/PharmacyReports/StockEditLogReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Edit Log Report' },

  '/PharmacyReports/DayWiseSalesGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'Sales GST' },
  '/PharmacyReports/DayWiseReturnGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'Return GST' },
  '/PharmacyReports/HSNwiseSalesGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'HSN Sales GST' },
  '/PharmacyReports/HSNwiseReturnGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'HSN Return GST' },
  '/PharmacyReports/DayWiseGSTSummary': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'GST Summary' },
  '/PharmacyReports/HSNWiseSummaryGST': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'HSN GST Summary' },
  '/PharmacyReports/NetGSTReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'GST Reports', subTab: 'Net GST Report' },

  '/PharmacyReports/GenerateReport': { module: 'Pharmacy', screen: 'Reports', mainTab: 'Accounts Report', subTab: 'Generate Report' },
  
  '/PharmacyReports/RefDoctorList': { module: 'Standalone Pharmacy', screen: 'Reports', mainTab: 'Pharmacy', subTab: 'Refferal Doctor' },
  '/PharmacyReports/PatientReport': { module: 'Standalone Pharmacy', screen: 'Reports', mainTab: 'Pharmacy', subTab: 'Patient' },

  '/PharmacyInternalSales/WantedList': { module: 'Pharmacy', screen: 'Internal Sales', mainTab: 'Wanted List' },
  '/PharmacyInternalSales/RequestList': { module: 'Pharmacy', screen: 'Internal Sales', mainTab: 'Request List' },
  '/PharmacyInternalSales/SalesReport': { module: 'Pharmacy', screen: 'Internal Sales', mainTab: 'Internal Sales Report' },
  '/PharmacyInternalSales/InternalTaxReport': { module: 'Pharmacy', screen: 'Internal Sales', mainTab: 'Internal Tax Report' },
  '/PharmacyInternalSales/InvoiceReport': { module: 'Pharmacy', screen: 'Internal Sales', mainTab: 'Invoice Report' },
  '/PharmacyStockTransfer': { module: 'Pharmacy', screen: 'Stock Transfer' },
  // Note: PharmacyStockTransfer routes with isBranch are handled dynamically in getPackageInfoFromPath
  '/PharmacyStockTransfer/PharmaBranchWanted': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Wanted List' },
  '/PharmacyStockTransfer/PharmaBranchInbound': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Inbound' },
  '/PharmacyStockTransfer/PharmaBranchOutbound': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Outbound' },
  '/PharmacyStockTransfer/PharmaBranchReturn': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Return Request' },
  '/PharmacyStockTransfer/PharmaBranchStockTransReport': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Stock Transfer Report' },
  '/PharmacyStockTransfer/PharmaBranchDrugWiseStockTransReport': { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inter Branch Stock Movement', subTab: 'Drug Wise Stock Transfer Report' },
  '/PharmacyInternalSales': { module: 'Pharmacy', screen: 'Internal Sales' },
  '/PharmacySetting': { module: 'Pharmacy', screen: 'Settings' },
  '/PharmacySetting/PrintConfig': { module: 'Pharmacy', screen: 'Settings', mainTab: 'Print Configuration' },
  '/PharmacySetting/Settings': { module: 'Pharmacy', screen: 'Settings', mainTab: 'Settings' },
  '/PharmacySetting/GenericName': { module: 'Pharmacy', screen: 'Settings', mainTab: 'Generic Name' },
  '/PharmacySetting/DoctorList': { module: 'Pharmacy', screen: 'Settings', mainTab: 'External Doctor List' },

  // =================== LABORATORY ===================
  '/LabHome': { module: 'Laboratory', screen: 'Home' },
  '/MainHome': { module: 'Laboratory', screen: 'Home' },
  '/MainHome/CreateBill': { module: 'Laboratory', screen: 'Home', mainTab: 'Create Bill' },
  '/MainHome/Status': { module: 'Laboratory', screen: 'Home', mainTab: 'Status' },
  '/MainHome/TestReport': { module: 'Laboratory', screen: 'Home', mainTab: 'Test Report' },
  '/MainHome/ForTechnicians': { module: 'Laboratory', screen: 'Home', mainTab: 'For Technicians' },
  '/MainHome/OutsourceList': { module: 'Laboratory', screen: 'Home', mainTab: 'Outsource List' },
  '/MainHome/CancelledBill': { module: 'Laboratory', screen: 'Home', mainTab: 'Cancelled Bill' },
  '/MainHome/Order': { module: 'Laboratory', screen: 'Home', mainTab: 'Order' },
  '/LabReports': { module: 'Laboratory', screen: 'Reports' },
  '/LabBilling': { module: 'Laboratory', screen: 'Lab Billing' },
  '/Inventory': { module: 'Laboratory', screen: 'Inventory' },
  '/Inventory/StockList': { module: 'Laboratory', screen: 'Inventory', mainTab: 'Stock List' },
  '/Inventory/ActiveInventory': { module: 'Laboratory', screen: 'Inventory', mainTab: 'Active Inventory' },
  '/Inventory/InactiveInventory': { module: 'Laboratory', screen: 'Inventory', mainTab: 'Inactive Inventory' },
  '/Inventory/NoMovementInventory': { module: 'Laboratory', screen: 'Inventory', mainTab: 'No Movement Inventory' },
  '/Inventory/ShortExpiryStock': { module: 'Laboratory', screen: 'Inventory', mainTab: 'Short Expiry Stock' },
  '/Inventory/NewProductStatus': { module: 'Laboratory', screen: 'Inventory', mainTab: 'New Product Status' },
  '/Inventory/ExpiredStock': { module: 'Laboratory', screen: 'Inventory', mainTab: 'Expired Stock' },
  '/Purchase': { module: 'Laboratory', screen: 'Purchase' },
  '/Purchase/WantedList': { module: 'Laboratory', screen: 'Purchase', mainTab: 'Wanted List' },
  '/Purchase/PurchaseOrder': { module: 'Laboratory', screen: 'Purchase', mainTab: 'Purchase Order' },
  '/Purchase/VendorPayment': { module: 'Laboratory', screen: 'Purchase', mainTab: 'Vendor Payment' },
  '/Purchase/VendorList': { module: 'Laboratory', screen: 'Purchase', mainTab: 'Vendor List' },
  '/SettingsHome': { module: 'Laboratory', screen: 'Settings' },
  // Lab Masters
  '/SettingsHome/LabMaster/DepartmentMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Department Master' },
  '/SettingsHome/LabMaster/ContainerMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Container Master' },
  '/SettingsHome/LabMaster/SpecimenMster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Specimen Master' },
  '/SettingsHome/LabMaster/MethodMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Method Master' },
  '/SettingsHome/LabMaster/AntibioticMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Antibiotic Master' },
  '/SettingsHome/LabMaster/OrganismMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Organism Master' },
  '/SettingsHome/LabMaster/OrganismVsAntibioticGrp': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Organism Vs Antibiotic Name' },
  '/SettingsHome/LabMaster/AnalyserMaster': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Masters', subTab: 'Analyser Master' },
  // Lab Configuration
  '/SettingsHome/ConsumableConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Consumable Mapping' },
  '/SettingsHome/PatientDemographics': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Patient Demographics' },
  '/SettingsHome/ReferredDoctor': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Referred Doctor' },
  '/SettingsHome/OutsourceConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Outsource Configuration' },
  '/SettingsHome/OutsourceMapping': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Outsource Mapping' },
  '/SettingsHome/ResultConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Result Configuration' },
  '/SettingsHome/SignatureConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Lab E-Signature Configuration' },
  '/SettingsHome/PrintConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Print Configuration' },
  '/SettingsHome/TestConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Test Configuration' },
  '/SettingsHome/GroupConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Test Group' },
  '/SettingsHome/PackageConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Package Configuration' },
  '/SettingsHome/TemplateConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Template Configuration' },
  '/SettingsHome/DoctorConfiguration': { module: 'Laboratory', screen: 'Settings', mainTab: 'Lab Configuration', subTab: 'Doctor Share Configuration' },
  // Lab Reports - Financial Reports
  '/LabReports/FinancialReport/BillReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Bill Report' },
  '/LabReports/FinancialReport/LabReceiptBills': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Receipt Bills' },
  '/LabReports/FinancialReport/LabCensusReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Census Report' },
  '/LabReports/FinancialReport/LabDayEndReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Day End Report' },
  '/LabReports/FinancialReport/CorporateBillReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Corporate Bill Report' },
  '/LabReports/FinancialReport/InsuranceReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Insurance Report' },
  '/LabReports/FinancialReport/LabShareReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Lab Share Report' },
  '/LabReports/FinancialReport/TestCensusReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Test Census Report' },
  '/LabReports/FinancialReport/DayEndDenomination': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Day End Denomination' },
  '/LabReports/FinancialReport/ConsultantWiseReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Consultant Wise Report' },
  '/LabReports/FinancialReport/Expenses': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Expenses' },
  '/LabReports/FinancialReport/LabBillingReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Financial Reports', subTab: 'Lab Billing Report' },
  // Lab Reports - Patient Reports
  '/LabReports/PatientReport/LabPatientReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Patient Report' },
  '/LabReports/PatientReport/LabResultCensusReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'Diagnostic Census Report' },
  '/LabReports/PatientReport/IpAdmissionReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Patient Reports', subTab: 'IP Admission List' },
  // Lab Reports - Business Reports
  '/LabReports/BusinessReport/DoctorReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Referred Doctor Report' },
  '/LabReports/BusinessReport/OutSourceReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Outsource Report' },
  '/LabReports/BusinessReport/GroupwiseReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Group Wise Report' },
  '/LabReports/BusinessReport/GroupwiseSummaryReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Group Wise Summary' },
  '/LabReports/BusinessReport/TestwiseReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Test Wise Report' },
  '/LabReports/BusinessReport/TestwiseSummaryReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Test Wise Summary' },
  '/LabReports/BusinessReport/PackageWiseReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'Package Wise Report' },
  '/LabReports/BusinessReport/TatReport': { module: 'Laboratory', screen: 'Reports', mainTab: 'Business Reports', subTab: 'TAT Report' },
  // Lab Billing - Billing Tabs
  '/LabBilling': { module: 'Laboratory', screen: 'Lab Billing' },
  '/LabBilling/HospitalBilling': { module: 'Laboratory', screen: 'Lab Billing', mainTab: 'Hospital Billing' },
  '/LabBilling/CashCounter': { module: 'Laboratory', screen: 'Lab Billing', mainTab: 'Cash Counter' },
  '/LabBilling/PendingList': { module: 'Laboratory', screen: 'Lab Billing', mainTab: 'Pending List' },


  // =================== STORE ===================
  '/StorePurchase': { module: 'store_module', screen: 'Purchase' },
  '/StorePurchase/PurchaseRequest': { module: 'store_module', screen: 'Purchase', mainTab: 'Purchase Request' },
  '/StorePurchase/PurchaseInward': { module: 'store_module', screen: 'Purchase', mainTab: 'Purchase Inward' },
  '/StorePurchase/PurchaseRejection': { module: 'store_module', screen: 'Purchase', mainTab: 'Purchase Rejection' },
  '/StorePurchase/CreditNote': { module: 'store_module', screen: 'Purchase', mainTab: 'Credit Note' },
  '/StorePurchase/VendorPayment': { module: 'store_module', screen: 'Purchase', mainTab: 'Vendor Payment' },
  '/StorePurchase/WantedList': { module: 'store_module', screen: 'Purchase', mainTab: 'Wanted List' },
  '/StorePurchase/Audit': { module: 'store_module', screen: 'Purchase', mainTab: 'Audit' },
  '/StoreInventory': { module: 'store_module', screen: 'Inventory' },
  '/StoreInventory/ProductList': { module: 'store_module', screen: 'Inventory', mainTab: 'Product List' },
  '/StoreInventory/StockCorrection': { module: 'store_module', screen: 'Inventory', mainTab: 'Stock Correction' },
  '/StoreReports': { module: 'store_module', screen: 'Reports' },
  // Store Reports - Inventory reports
  '/StoreReports/StockValue': { module: 'store_module', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Value Report' },
  '/StoreReports/StockReport': { module: 'store_module', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Stock Report' },
  '/StoreReports/ShortExpiry': { module: 'store_module', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Short Expiry' },
  '/StoreReports/StockLowStock': { module: 'store_module', screen: 'Reports', mainTab: 'Inventory Reports', subTab: 'Low Stock' },
  // Store Reports - Purchase reports
  '/StoreReports/PurchaseReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Request' },
  '/StoreReports/PurchaseReturnReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return Report' },
  '/StoreReports/PurchaseHSNReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase HSN Report' },
  '/StoreReports/PurchaseGSTReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase GST Report' },
  '/StoreReports/PurchaseReturnHSNReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return HSN Report' },
  '/StoreReports/PurchaseReturnGSTReport': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Purchase Return GST Report' },
  '/StoreReports/VendorPerformance': { module: 'store_module', screen: 'Reports', mainTab: 'Purchase Reports', subTab: 'Vendor Performance' },
  // Store Reports - Transfer reports
  '/StoreReports/TransferList': { module: 'store_module', screen: 'Reports', mainTab: 'Transfer Reports', subTab: 'Transfer List' },
  '/StoreReports/ReturnTransSubLoc': { module: 'store_module', screen: 'Reports', mainTab: 'Transfer Reports', subTab: 'Return Transfer Sublocation' },
  '/StoreSetting': { module: 'store_module', screen: 'Masters' },
  '/StoreSetting/Vendor': { module: 'store_module', screen: 'Masters', mainTab: 'Vendor' },
  '/StoreSetting/Department': { module: 'store_module', screen: 'Masters', mainTab: 'Department' },
  '/StoreSetting/Category': { module: 'store_module', screen: 'Masters', mainTab: 'Category' },
  '/StoreSetting/SubCategory': { module: 'store_module', screen: 'Masters', mainTab: 'Sub Category' },
  '/StoreSetting/ProductType': { module: 'store_module', screen: 'Masters', mainTab: 'Product Type' },
  '/StoreSetting/Products': { module: 'store_module', screen: 'Masters', mainTab: 'Products' },
  '/StoreSetting/VendorMapping': { module: 'store_module', screen: 'Masters', mainTab: 'Vendor Mapping' },
  '/StoreTransfer': { module: 'store_module', screen: 'Store' },
  '/StoreTransfer/IndentRise': { module: 'store_module', screen: 'Store', mainTab: 'Inbound' },
  '/StoreTransfer/IndentReceive': { module: 'store_module', screen: 'Store', mainTab: 'Outbound' },
  '/StoreTransfer/StockTranferReport': { module: 'store_module', screen: 'Store', mainTab: 'Stock Tranfer Report' },

  // =================== MRD ===================
  '/MrdHome': { module: 'master_record_department', screen: 'Home' },
  '/MrdHome/TransferRequest': { module: 'master_record_department', screen: 'Home', mainTab: 'Transfer Request' },
  '/MrdAudit': { module: 'master_record_department', screen: 'Audit Track' },
  '/MrdMasters': { module: 'master_record_department', screen: 'Masters' },
  '/MrdMasters/Category': { module: 'master_record_department', screen: 'Masters', mainTab: 'MRD Category' },
  '/MrdMasters/Location': { module: 'master_record_department', screen: 'Masters', mainTab: 'MRD Rack' },

  // =================== SUBLOCATION ===================
  '/SubLocationBilling': { module: 'sub_location', screen: 'Home', mainTab: 'Patient Billing' },
  '/SubLocationBilling/GenericConsumption': { module: 'sub_location', screen: 'Home', mainTab: 'Generic Consumption' },
  '/SubLocationReports': { module: 'sub_location', screen: 'Reports', mainTab: 'Stock List' },
  '/SubLocationReports/ShortExpiry': { module: 'sub_location', screen: 'Reports', mainTab: 'Short Expiry' },
  '/SubLocationReports/CreditReport': { module: 'sub_location', screen: 'Reports', mainTab: 'Credit Report' },
  '/SubLocationReports/ConsumptionReport': { module: 'sub_location', screen: 'Reports', mainTab: 'Consumption Report' },
  '/SubLocationReports/ExpiryStock': { module: 'sub_location', screen: 'Reports', mainTab: 'Expiry Stock' },
  '/SubLocationReports/StockValueDetail': { module: 'sub_location', screen: 'Reports', mainTab: 'Stock Value Detail' },
  '/SubLocationReports/IssuedDrugReport': { module: 'sub_location', screen: 'Reports', mainTab: 'Issued Drug Report' },
  '/SubLocationStockTransfer': { module: 'sub_location', screen: 'Stock Transfer' },
  '/SubLocationStockTransfer/WantedList': { module: 'sub_location', screen: 'Stock Transfer', mainTab: 'Wanted List' },
  '/SubLocationStockTransfer/Inbound': { module: 'sub_location', screen: 'Stock Transfer', mainTab: 'Inbound' },
  '/SubLocationStockTransfer/Outbound': { module: 'sub_location', screen: 'Stock Transfer', mainTab: 'Outbound' },
  '/SubLocationStockTransfer/ReturnRequest': { module: 'sub_location', screen: 'Stock Transfer', mainTab: 'Return Request' },
  '/SubLocationStockTransfer/StockTransferReport': { module: 'sub_location', screen: 'Stock Transfer', mainTab: 'Stock Transfer Report' },
  };
  
  return routeToPackageObj;
};

/**
 * Get investigation module route mappings dynamically using GetInvestigationName()
 */
const getInvestigationRouteMapping = (pathToCheck) => {
  const moduleName = GetInvestigationName();

  const investigationTemplates = {
    'Home': { screen: 'Home' },
    // 'Home/Demographics': { screen: 'Home', mainTab: 'Quick Billing & Demographics' },
    // 'Home/NewQuickBilling': { screen: 'Home', mainTab: 'Quick Billing' },
    'Home/Demographics/Update': { screen: 'Home', mainTab: 'Demographics' },
    'Home/Patient/Demographics': { screen: 'Home', mainTab: 'Demographics' },
    'Home/Patient/Billing': { screen: 'Home', mainTab: 'Billing' },
    'Home/Patient/Billing/SavedBill': { screen: 'Home', mainTab: 'Billing', subTab: 'Saved Bill' },
    'Home/Patient/Billing/Bills': { screen: 'Home', mainTab: 'Billing', subTab: 'Bills' },
    'Home/Patient/Billing/ReceiptBills': { screen: 'Home', mainTab: 'Billing', subTab: 'Receipts' },
    'Home/Patient/Reports': { screen: 'Home', mainTab: 'Reports' },
    'Home/Patient/Reports/TestReports': { screen: 'Home', mainTab: 'Reports', subTab: 'Test Reports' },
    'Home/Patient/Reports/Notes': { screen: 'Home', mainTab: 'Reports', subTab: 'Notes' },
    'Home/Order': { screen: 'Home', mainTab: 'Order' },
    'Billing': { screen: (localGetItem('investigation_name') ? 'Investigation Billing' : "Radiology Billing") },
    'Billing/HospitalBilling': { screen: (localGetItem('investigation_name') ? 'Investigation Billing' : "Radiology Billing"), mainTab: 'Hospital Billing' },
    'Billing/CashCounter': { screen: (localGetItem('investigation_name') ? 'Investigation Billing' : "Radiology Billing"), mainTab: 'Cash Counter' },
    'Billing/PendingList': { screen: (localGetItem('investigation_name') ? 'Investigation Billing' : "Radiology Billing"), mainTab: 'Pending List' },
    'BillingTransaction': { screen: 'Billing Transaction' },
    'BillingTransaction/OverallBills': { screen: 'Billing Transaction', mainTab: 'Overall Bills' },
    'BillingTransaction/CreditBills': { screen: 'Billing Transaction', mainTab: 'Credit Bills' },
    'BillingTransaction/CancelledBills': { screen: 'Billing Transaction', mainTab: 'Cancelled Bills' },
    'BillingTransaction/SavedBills': { screen: 'Billing Transaction', mainTab: 'Saved Bills' },
    'BillingTransaction/ReceiptBills': { screen: 'Billing Transaction', mainTab: 'Receipt Bills' },
    'BillingTransaction/DayEndStatus': { screen: 'Billing Transaction', mainTab: 'Day End' },
    'BillingTransaction/DayEndDenomination': { screen: 'Billing Transaction', mainTab: 'Day End Denomination' },
    'BillingTransaction/Expenses': { screen: 'Billing Transaction', mainTab: 'Expenses' },
    'Order': { screen: 'Order' },
    'Order/Order': { screen: 'Order', mainTab: 'Create Order' },
    'Order/PendingList': { screen: 'Order', mainTab: 'Pending List' },
    'Order/AcceptedOrder': { screen: 'Order', mainTab: 'Accepted Order' },
    'Order/CancelledOrder': { screen: 'Order', mainTab: 'Cancelled Order' },
    'Reports': { screen: 'Reports' },
    'Reports/Census': { screen: 'Reports', mainTab: 'Census Report' },
    'Reports/PatientReport': { screen: 'Reports', mainTab: 'Patient Report' },
    'Reports/ConsultantWiseReport': { screen: 'Reports', mainTab: 'Consultant Wise Report' },
    'Reports/TATReport': { screen: 'Reports', mainTab: 'TAT Report' },
    'Reports/CorporatePatientBillReport': { screen: 'Reports', mainTab: 'Corporate Patient Bill Report' },
    'Settings': { screen: 'Settings' },
    'Settings/ServiceConfig': { screen: 'Settings', mainTab: 'Service Name & Type Configuration' },
    'Settings/ServiceTemplateConfig': { screen: 'Settings', mainTab: 'Result Template' },
    'Settings/ServiceTemplateConfig/Template': { screen: 'Settings', mainTab: 'Result Template' },
    'Settings/PrintConfig': { screen: 'Settings', mainTab: 'Print Configuration' },
    'Settings/ResultConfig': { screen: 'Settings', mainTab: 'Result Configuration' },
    'Settings/E-Signature': { screen: 'Settings', mainTab: 'E-Signature Configuration' },
    'Settings/ReferredDoctor': { screen: 'Settings', mainTab: 'Referred Doctor' },
  };

  const investigationModulePrefixes = ['radiology', 'investigation', 'scopy', 'audiometry', 'endoscopy'];
  const pathLower = pathToCheck.toLowerCase();
  const pathWithoutSlash = pathToCheck.substring(1);

  for (const prefix of investigationModulePrefixes) {
    if (pathLower.startsWith(`/${prefix}`)) {
      const pathAfterModule = pathWithoutSlash.substring(prefix.length);
      const templateKey = pathAfterModule.startsWith('/') ? pathAfterModule.substring(1) : pathAfterModule;

      if (investigationTemplates[templateKey]) {
        return { module: moduleName, ...investigationTemplates[templateKey] };
      }

      if (templateKey === '' || Object.keys(investigationTemplates).includes(templateKey)) {
        const baseKey = templateKey || 'Home';
        if (investigationTemplates[baseKey]) {
          return { module: moduleName, ...investigationTemplates[baseKey] };
        }
      }
    }
  }

  return null;
};

/** Get Store Sub Location route mappings dynamically */
const getStoreSubLocationRouteMapping = (pathToCheck) => {
  const storeSubLocationTemplates = {
    'GenericConsumption': { screen: 'Store', mainTab: 'Generic Consumption' },
    'LowStock': { screen: 'Store', mainTab: 'Low Stock' },
    'ExpiryAlert': { screen: 'Store', mainTab: 'Expiry Alert' },
    'IndentRise': { screen: 'Store', mainTab: 'Inbound' },
    'IndentReceive': { screen: 'Store', mainTab: 'Outbound' },
    'ReturnRequest': { screen: 'Store', mainTab: 'Return Request' },
    'StockList': { screen: 'Store', mainTab: 'Stock List' },
    'StockTranferReport': { screen: 'Store', mainTab: 'Stock Tranfer Report' },
    'WantedList': { screen: 'Store', mainTab: 'Wanted List' },
    'Audit': { screen: 'Store', mainTab: 'Audit' },
  };

  const storeTransferPrefixes = ['/FOStoreTransfer', '/LabStoreTransfer', '/RadiologyStoreTransfer', '/PharmacyStoreTransfer', '/StoreTransfer'];

  for (const prefix of storeTransferPrefixes) {
    if (pathToCheck.startsWith(prefix)) {
      const pathAfterPrefix = pathToCheck.substring(prefix.length);
      const templateKey = pathAfterPrefix.startsWith('/') ? pathAfterPrefix.substring(1) : pathAfterPrefix;
      const moduleName = prefix === '/StoreTransfer' ? 'store_module' : 'Store Sub Location';

      if (storeSubLocationTemplates[templateKey]) {
        return { module: moduleName, ...storeSubLocationTemplates[templateKey] };
      }

      if (templateKey === '') {
        return { module: moduleName, screen: 'Store' };
      }
    }
  }

  return null;
};

/** Get package_access modules from localStorage */
const getPackageAccessModules = () => {
  try {
    const packageAccessStr = localStorage.getItem('package_access');
    if (!packageAccessStr) return [];

    const packageAccess = JSON.parse(packageAccessStr);

    // Handle different structures
    if (Array.isArray(packageAccess)) {
      return packageAccess;
    }
    if (packageAccess?.modules && Array.isArray(packageAccess.modules)) {
      return packageAccess.modules;
    }
    return [];
  } catch (e) {
    console.error('Error parsing package_access:', e);
    return [];
  }
};

/** Get original_package_access modules from localStorage */
const getOriginalPackageAccessModules = () => {
  try {
    const originalAccessStr = localStorage.getItem('original_package_access');
    if (!originalAccessStr) return null;

    const originalAccess = JSON.parse(originalAccessStr);

    // Handle different structures
    if (Array.isArray(originalAccess)) {
      return originalAccess;
    }
    if (originalAccess?.modules && Array.isArray(originalAccess.modules)) {
      return originalAccess.modules;
    }
    return null;
  } catch (e) {
    console.error('Error parsing original_package_access:', e);
    return null;
  }
};

/** Get loggedInUserInfo from localStorage */
const getUserInfo = () => {
  try {
    const userInfoStr = localStorage.getItem('loggedInUserInfo');
    if (!userInfoStr) return null;
    return JSON.parse(userInfoStr);
  } catch (e) {
    console.error('Error parsing loggedInUserInfo:', e);
    return null;
  }
};

/** Get module type from a module object */
const getModuleType = (mod) => {
  if (mod.moduels) return mod.moduels;

  if (mod.module_name && !mod.moduels) {
    const adminModuleTypes = ['front_office', 'Pharmacy', 'Laboratory', 'Radiology',
      'Investigation', 'store_module', 'master_record_department', 'Radiotherapy',
      'sub_location', 'Store Sub Location', 'ot_management', 'counsellor',
      'asset_management', 'Doctor', 'canteen',
      'ENDOSCOPY', 'AUDIOMETRY', 'SCOPY', 'Endoscopy', 'Audiometry', 'Scopy'];
    if (adminModuleTypes.includes(mod.module_name)) {
      return mod.module_name;
    }
  }

  if (mod.module_access?.[0]?.module_type) {
    return mod.module_access[0].module_type;
  }

  return mod.module_type || mod.module_name;
};

/** Get current module type from loggedInUserInfo */
const getCurrentModuleType = () => {
  const userInfo = getUserInfo();
  if (!userInfo) return null;
  return userInfo.module_name;
};

/** Get current module ID for multi-instance modules */
const getCurrentModuleId = (moduleType) => {
  const userInfo = getUserInfo();
  if (!userInfo) return null;

  const idKey = MODULE_ID_KEYS[moduleType];
  if (!idKey) return null;

  return userInfo[idKey];
};

/** Normalize investigation module types for comparison */
const normalizeModuleType = (moduleType) => {
  if (!moduleType) return null;

  const investigationVariants = ['investigation', 'endoscopy', 'audiometry', 'scopy'];
  if (investigationVariants.includes(moduleType.toLowerCase())) {
    return 'Investigation';
  }

  return moduleType;
};

/** Check if two module types are equivalent */
const moduleTypesMatch = (type1, type2) => {
  if (!type1 || !type2) return false;
  if (type1 === type2) return true;
  return normalizeModuleType(type1) === normalizeModuleType(type2);
};

/** Find the module in modules array that matches current user's module */
const findCurrentModule = (modules, targetModuleType = null) => {
  if (!modules || !Array.isArray(modules) || modules.length === 0) return null;

  const moduleType = targetModuleType || getCurrentModuleType();
  if (!moduleType) return null;

  const moduleId = getCurrentModuleId(moduleType);

  for (const mod of modules) {
    const modType = getModuleType(mod);
    const matches = moduleTypesMatch(modType, moduleType);

    if (!matches) continue;

    if (moduleId && MODULE_ID_KEYS[moduleType]) {
      if (mod.module_id === moduleId) {
        return mod;
      }
    } else {
      return mod;
    }
  }

  const fallbackMod = modules.find(mod => moduleTypesMatch(getModuleType(mod), moduleType));
  return fallbackMod || null;
};

/** Find a tab in the module's package data */
const findTabInModule = (mod, screenTitle, mainTabTitle = null, subTabTitle = null) => {
  if (!mod?.module_access) return null;

  for (const access of mod.module_access) {
    for (const screen of access.data || []) {
      // Match screen
      if (screen.title !== screenTitle) continue;

      // If only looking for screen level
      if (!mainTabTitle) {
        return {
          is_locked: screen.is_locked === true,
          viewAccess: screen.viewAccess,
          editAccess: screen.editAccess
        };
      }

      // Look for main tab
      for (const mainTab of screen.main_tabs || []) {
        if (mainTab.title !== mainTabTitle) continue;

        // If only looking for main tab level
        if (!subTabTitle) {
    return {
            is_locked: mainTab.is_locked === true,
            viewAccess: mainTab.viewAccess,
            editAccess: mainTab.editAccess
    };
  }
  
        // Look for sub tab
        for (const subTab of mainTab.sub_tabs || []) {
          if (subTab.title === subTabTitle) {
    return {
              is_locked: subTab.is_locked === true,
              viewAccess: subTab.viewAccess,
              editAccess: subTab.editAccess
            };
          }
        }
      }
    }
  }

  return null;
};

/** Check if a tab exists in the module's package data */
const tabExistsInModule = (mod, screenTitle, mainTabTitle = null, subTabTitle = null) => {
  return findTabInModule(mod, screenTitle, mainTabTitle, subTabTitle) !== null;
};

/** Get Pharmacy Stock Transfer route mapping dynamically based on isBranch */
const getPharmacyStockTransferRouteMapping = (pathToCheck) => {
  const isBranch = getIsBranch();
  
  const pharmacyStockTransferRoutes = {
    '/PharmacyStockTransfer/Inbound': isBranch 
      ? { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Sub Location Transfer', subTab: 'Inbound' }
      : { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Inbound' },
    '/PharmacyStockTransfer/Outbound': isBranch
      ? { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Sub Location Transfer', subTab: 'Outbound' }
      : { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Outbound' },
    '/PharmacyStockTransfer/StockTransferReport': isBranch
      ? { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Sub Location Transfer', subTab: 'Stock Transfer Report' }
      : { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Stock Transfer Report' },
    '/PharmacyStockTransfer/PharmaSubStockList': isBranch
      ? { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Sub Location Transfer', subTab: 'Stock List' }
      : { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Stock List' },
    '/PharmacyStockTransfer/PharmaDrugWiseStockTransfer': isBranch
      ? { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Sub Location Transfer', subTab: 'Drug Wise Stock Transfer Report' }
      : { module: 'Pharmacy', screen: 'Stock Transfer', mainTab: 'Drug Wise Stock Transfer Report' },
  };
  
  return pharmacyStockTransferRoutes[pathToCheck] || null;
};

/** Get package info from a route path (exact match, then one level up) */
const getPackageInfoFromPath = (path) => {
  if (!path) return null;
  const ROUTE_TO_PACKAGE = getRouteToPackage();

  const investigationMapping = getInvestigationRouteMapping(path);
  if (investigationMapping) return investigationMapping;

  const storeSubLocationMapping = getStoreSubLocationRouteMapping(path);
  if (storeSubLocationMapping) return storeSubLocationMapping;

  // Check Pharmacy Stock Transfer routes dynamically (depends on isBranch)
  const pharmacyStockTransferMapping = getPharmacyStockTransferRouteMapping(path);
  if (pharmacyStockTransferMapping) return pharmacyStockTransferMapping;

  if (ROUTE_TO_PACKAGE[path]) return ROUTE_TO_PACKAGE[path];

  const lastSlashIndex = path.lastIndexOf('/');
  if (lastSlashIndex > 0) {
    const parentPath = path.substring(0, lastSlashIndex);

    const parentInvestigationMapping = getInvestigationRouteMapping(parentPath);
    if (parentInvestigationMapping) return parentInvestigationMapping;

    const parentStoreSubLocationMapping = getStoreSubLocationRouteMapping(parentPath);
    if (parentStoreSubLocationMapping) return parentStoreSubLocationMapping;

    const parentPharmacyStockTransferMapping = getPharmacyStockTransferRouteMapping(parentPath);
    if (parentPharmacyStockTransferMapping) return parentPharmacyStockTransferMapping;

    if (ROUTE_TO_PACKAGE[parentPath]) return ROUTE_TO_PACKAGE[parentPath];
  }

  return null;
};

/** Get module type from a menu item's path */
const getModuleFromPath = (path) => {
  const info = getPackageInfoFromPath(path);
  return info?.module || null;
};

/** Check if package access is empty */
const isPackageAccessEmpty = () => {
  const modules = getPackageAccessModules();
  return !modules || modules.length === 0;
};

/** Check if user is a doctor */
const isDoctor = () => {
  const userInfo = getUserInfo();
  return userInfo?.is_doctor === true;
};

/** Check if a tab should be visible/accessible */
const checkTabAccess = (moduleType, screenTitle, mainTabTitle = null, subTabTitle = null, role = 'user') => {
  const defaultResult = { visible: true, locked: false, viewAccess: true, editAccess: true };

  if (isPackageAccessEmpty() || isDoctor()) return defaultResult;

  const packageModules = getPackageAccessModules();
  const currentMod = findCurrentModule(packageModules, moduleType);

  if (!currentMod) {
    return role === 'admin' ? defaultResult : { visible: false, locked: false, viewAccess: false, editAccess: false };
  }

  const tabInfo = findTabInModule(currentMod, screenTitle, mainTabTitle, subTabTitle);

  if (!tabInfo) {
    return role === 'admin' ? defaultResult : { visible: false, locked: false, viewAccess: false, editAccess: false };
  }

  if (role === 'admin') {
    return { visible: true, locked: tabInfo.is_locked === true, viewAccess: true, editAccess: true };
  }

  const originalModules = getOriginalPackageAccessModules();
  if (originalModules) {
    const originalMod = findCurrentModule(originalModules, moduleType);
    if (originalMod && !tabExistsInModule(originalMod, screenTitle, mainTabTitle, subTabTitle)) {
      return { visible: false, locked: false, viewAccess: false, editAccess: false };
    }
    if (originalMod) {
      const originalTabInfo = findTabInModule(originalMod, screenTitle, mainTabTitle, subTabTitle);
      if (originalTabInfo?.is_locked === true) {
        return { visible: false, locked: true, viewAccess: false, editAccess: false };
      }
    }
  }

  if (tabInfo.is_locked === true || tabInfo.viewAccess === false) {
    return { visible: false, locked: tabInfo.is_locked === true, viewAccess: false, editAccess: false };
  }

  return { visible: true, locked: false, viewAccess: tabInfo.viewAccess !== false, editAccess: tabInfo.editAccess === true };
};

/** Filter menu items by subscription/package access */
export const filterMenuBySubscription = (rawMenuList, subscriptionData, role) => {
  if (!rawMenuList || !Array.isArray(rawMenuList)) return [];

  if (isPackageAccessEmpty() || isDoctor()) {
    return rawMenuList.map(item => ({
      ...item,
      is_locked: false,
      subMenu: (item?.subMenu || []).map(sm => ({ ...sm, is_locked: false }))
    }));
  }

  return rawMenuList
    .map(item => {
      const packageInfo = getPackageInfoFromPath(item.path);
      const accessResult = packageInfo
        ? checkTabAccess(packageInfo.module, packageInfo.screen, packageInfo.mainTab, packageInfo.subTab, role)
        : { visible: true, locked: false, viewAccess: true, editAccess: true };

      if (role === 'admin') {
        const processedSubMenu = (item?.subMenu || []).map(sm => {
          const smPackageInfo = getPackageInfoFromPath(sm.path);
          const smAccessResult = smPackageInfo
            ? checkTabAccess(smPackageInfo.module, smPackageInfo.screen, smPackageInfo.mainTab, smPackageInfo.subTab, role)
            : { visible: true, locked: false };
          return { ...sm, is_locked: smAccessResult.locked };
        });
        return { ...item, is_locked: accessResult.locked, subMenu: processedSubMenu };
      }

      if (!accessResult.visible) return null;

      const processedSubMenu = (item?.subMenu || [])
        .map(sm => {
          const smPackageInfo = getPackageInfoFromPath(sm.path);
          // If path is not in AccessUtils, it's not access-controlled - show by default
          if (!smPackageInfo) {
            return { ...sm, is_locked: false };
          }
          const smAccessResult = checkTabAccess(smPackageInfo.module, smPackageInfo.screen, smPackageInfo.mainTab, smPackageInfo.subTab, role);
          
          // If package check says not visible but item's own Access says viewAccess is true,
          // allow it (for cases where tab isn't defined in package structure but user has access)
          if (!smAccessResult.visible && sm.Access?.viewAccess === true) {
            return { ...sm, is_locked: false };
          }
          if (!smAccessResult.visible) return null;
          return { ...sm, is_locked: smAccessResult.locked };
        })
        .filter(Boolean);

      return { ...item, is_locked: accessResult.locked, subMenu: processedSubMenu };
    })
    .filter(Boolean);
};

/** Check if user has access to a specific path */
export const hasAccess = (subscriptionData, role, path) => {
  if (isPackageAccessEmpty() || isDoctor()) return { allowed: true, locked: false };

  const packageInfo = getPackageInfoFromPath(path);
  if (!packageInfo) return { allowed: true, locked: false };

  const accessResult = checkTabAccess(packageInfo.module, packageInfo.screen, packageInfo.mainTab, packageInfo.subTab, role);

  if (role === 'admin') return { allowed: true, locked: accessResult.locked };

  return { allowed: accessResult.visible, locked: accessResult.locked };
};

/** Get subscription data for a specific title within a screen (legacy) */
export const getSubscriptionDataForTitleWithScreen = (title, subscriptionData, moduleName, screenToSearch, originalPackageAccess = null, mainTabToSearch = null) => {
  const titleOnly = title?.includes(':') ? title.split(':')[1] : title;

  const contextToModuleMap = {
    'opHome': 'front_office', 'ipHome': 'front_office', 'hospitalBilling': 'front_office',
    'billingTransaction': 'front_office', 'reports': 'front_office', 'settings': 'front_office',
    'RTWalkIn': 'front_office', 'pharmacy': 'Pharmacy', 'Store': 'store_module',
    'MRD': 'master_record_department', 'SubLocation': 'sub_location'
  };
  const moduleType = contextToModuleMap[moduleName] || moduleName;

  if (isPackageAccessEmpty()) return null;

  const currentMod = findCurrentModule(getPackageAccessModules(), moduleType);
  if (!currentMod) return null;

  const tabInfo = findTabInModule(currentMod, screenToSearch, mainTabToSearch, titleOnly);
  if (!tabInfo) {
    const tabInfoWithoutMainTab = findTabInModule(currentMod, screenToSearch, titleOnly);
    if (tabInfoWithoutMainTab) return { is_locked: tabInfoWithoutMainTab.is_locked === true, level: 'main_tab' };
    return null;
  }

  return { is_locked: tabInfo.is_locked === true, level: mainTabToSearch ? 'sub_tab' : 'main_tab' };
};

